import React from 'react'
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import { withCookies } from 'react-cookie'
import Cookies from 'js-cookie'

import Login from './views/Login/container'
import NotPageFound from './views/NotPageFound/container'
import ProductItem from './views/ProductItem/container'
import SelectAction from './views/SelectAction/container'
import RcfjCustomSize from './views/RcfjCustomSize/container'
import CustomSizeOverview from './views/RcfjCustomSize/CustomSizeOverview/container'
import CustomSizeConfirmation from './views/RcfjCustomSize/CustomSizeConfirmation/container'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'antd/dist/antd.css'
import './App.scss'


const PrivateRoute = ({ component, user, ...rest }) => {
  const orderId = Cookies.get('orderId')
  const customerId = Cookies.get('customerId')
  let isUser = false
  if(orderId && customerId){
    isUser = true
  }
  const isAuthed = isUser ? true : false
  return (
    <Route {...rest} exact
      render = {props => (
        isAuthed ? (<div>
          {
            React.createElement(component, props)
          }
        </div>)
        :
        (
          <Redirect
            to={{
              pathname: '/no-page-found',
              state: { from: props.location }
            }}
          />
        )
      )}
    />
  )
}

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      isAuthed: false
    }
  }

  componentDidMount() {
    // const cookies = new Cookies()
    // this.setState({ isLoading: false })
    // if (cookies.get('token')) {
    //   // this.checkUser();
    // } else {
    //   this.setState({ isLoading: false })
    // }
  }

  render() {
    // let { isAuthed, isLoading } = this.state
    return (
      <>
        {/* <Loader isLoading={isLoading} /> */}
        <div className="application-container">
          <Switch>
            <Route exact path="/" render={() =>
              <Redirect to="/login" />
            } />
            <Route exact path="/login" component={Login} {...this.props} />
            <Route exact path="/no-page-found" component={NotPageFound} {...this.props}/>

            <PrivateRoute exact path="/detail/:id" component={ProductItem} {...this.props} />
            <PrivateRoute exact path="/select-action/:id" component={SelectAction} {...this.props} />

            <PrivateRoute exact path="/confirm-size/:id" component={RcfjCustomSize} {...this.props} />
            <PrivateRoute exact path="/confirm-size/overview/:id" component={CustomSizeOverview} {...this.props} />
            <PrivateRoute exact path="/confirm-size/request-confirmation/:id" component={CustomSizeConfirmation} {...this.props} />

          </Switch>
        </div>
      </>
    )
  }
}

export default withRouter(withCookies(App))
